import { TAppRootState } from "../../../core/types";

import { gameModuleName } from "../slice";
import { IGameState } from "../types";

const select = (state: TAppRootState): IGameState => state[gameModuleName];

export const selectGameList = (state: TAppRootState) => select(state).gamesList;

export const selectStarted = (state: TAppRootState) => select(state).started;

export const selectResult = (state: TAppRootState) => select(state).result;

export const selectGameType = (state: TAppRootState) => select(state).type;

export const selectDifficulty = (state: TAppRootState) => select(state).difficulty;

export const selectIsSoundEnabled = (state: TAppRootState) => select(state).isSoundEnabled;
